module.exports = __webpack_public_path__ + "img/product_bg.4db3e15.png";